import { Bird, Bug, Cat, Dog } from "lucide-react";

export const FOCUS_TYPES = {
  owl: {
    key: "owl",
    name: "Eule",
    title: "Eule abholen",
    tagline: "Big Picture, Daten, Fakten",
    Icon: Bird,
    color: "text-indigo-600",
    bg: "bg-indigo-50",
    border: "border-indigo-100",
    ring: "ring-indigo-200",
  },
  bee: {
    key: "bee",
    name: "Biene",
    title: "Biene abholen",
    tagline: "Klare Schritte, Umsetzung",
    Icon: Bug,
    color: "text-amber-600",
    bg: "bg-amber-50",
    border: "border-amber-100",
    ring: "ring-amber-200",
  },
  cat: {
    key: "cat",
    name: "Katze",
    title: "Katze abholen",
    tagline: "Emotion, Optionen, Freiheit",
    Icon: Cat,
    color: "text-rose-500",
    bg: "bg-rose-50",
    border: "border-rose-100",
    ring: "ring-rose-200",
  },
  dog: {
    key: "dog",
    name: "Hund",
    title: "Hund abholen",
    tagline: "Konsequenz, Perspektive",
    Icon: Dog,
    color: "text-emerald-600",
    bg: "bg-emerald-50",
    border: "border-emerald-100",
    ring: "ring-emerald-200",
  },
};

export const FOCUS_ORDER = ["owl", "bee", "cat", "dog"];
